<template>
  <div>

    <h4 class="titulo-component">Fórmulário de Inscrição</h4>

    <div class="container-form">
      
        <el-row :gutter="10">

            <el-col :xs="24" :sm="24" :md="24">
                <label>Código de transferência</label>
                <el-input v-model="dados.codigo" v-mask="'###########'" maxlength="11" class="btn-pesquisar">
                    <el-button slot="append" @click="informaCodTransferencia()" type="primary">Continuar</el-button>
                </el-input>
                <div style="font-size: 12px; color: #a1a1a1; margin-top: 10px;" v-if="step == 1">
                  O código de transferência consta na declaração de transferência emitida pela instituição que o aluno concluiu em 2025.
                </div>
            </el-col>
                 
            <el-col :xs="24" :sm="24" :md="24" v-if="step > 1" class="u-mt-10">
                <label style="margin-bottom: 0px;">Selecione a instituição</label>
                <div style="font-size: 12px; color: #a1a1a1;" v-if="step == 2">
                  Apenas instituições com vagas disponíveis são exibidas.
                </div>
                <el-select v-model="dados.instituicao_id" filterable @change="selecionaInstituicao()">
                  <el-option
                      v-for="(item, i) in vagas"
                      :key="i"
                      :label="i"
                      :value="item.instituicao_id">
                      <span style="display: block;">{{ i }}</span>
                      <span style="display: block; color: #8492a6; font-size: 11px;">BAIRRO: {{ item.bairro }}</span>
                  </el-option>
                </el-select>
                
            </el-col>
      
            <el-col :xs="24" :sm="24" :md="24" v-if="step > 2" class="u-mt-10">
                <label>Selecione o turno</label>
                <el-select v-model="dados.turno" @change="selecionaTurno()">
                    <el-option v-for="(item, i) in turnos" :key="i" :label="i" :value="i"></el-option>
                </el-select>
            </el-col>
                      
            <el-col :xs="24" :sm="24" :md="24" v-if="step > 3" class="u-mt-10">
                <label>Selecione a modalidade</label>
                <el-select v-model="dados.modalidade" @change="selecionaModalidade()">
                    <el-option v-for="(item, i) in modalidades" :key="i" :label="i" :value="i">
                        <span>{{ i }} ({{ item.vagas }} {{ (item.vagas == 1 ? ' vaga' : ' vagas') }})</span>
                    </el-option>
                </el-select>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" v-if="step > 3" class="u-mt-10">
                <label>Telefone (opcional)</label>
                <el-input v-model="dados.telefone" v-mask="'(##) #########'" maxlength="191"></el-input>
            </el-col>

        </el-row>

        <div v-if="loadingInst" style="text-align: center; margin-top: 20px;">
          <img src="/public/img/loading-bar.gif" />
        </div>

        <el-alert v-if="erro" style="margin-top: 20px;" :title="erro" :closable="false" type="error" show-icon></el-alert>

        <div class="container-btns" v-if="step == 5">
          <el-button @click="onsubmit()" type="primary" :loading="loadingForm">Concluir</el-button>
        </div>            
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loadingInst: false,
      loadingForm: false,
      step: 1,
      instituicaoSelectIndex: null,
      matricula: {},
      vagas: {},
      turnos: {},
      modalidades: {},
      erro: '',
      dados: {
        codigo: '',
        instituicao_id: '',
        matricula_id: '',
        turno: '',
        modalidade: '',
        tipo_ensino: '',
        telefone: ''
      },
    };
  },
  methods: {
     informaCodTransferencia(){

      this.step = 1;

      this.dados.instituicao_id = '';
      this.dados.turno = '';
      this.dados.modalidade = '';
      this.dados.tipo_ensino = '';

      if(!this.dados.codigo){
        this.erro = 'Preencha o código de transferência.';
        return;
      }else{
        this.erro = '';
      }
      this.onSubmitBuscaMatricula();
      
      
    },
    selecionaInstituicao() {

      this.step = 2;

      this.dados.turno = '';
      this.dados.modalidade = '';
      this.dados.tipo_ensino = '';

      for(let i in this.vagas) {
        if(this.vagas[i].instituicao_id == this.dados.instituicao_id) {
          this.turnos = this.vagas[i].turnos;
        }
      }

      this.step++;
    },
    selecionaTurno() {

      this.step = 3;

      this.dados.modalidade = '';
      this.dados.tipo_ensino = '';

      for(let i in this.vagas) {
        if(this.vagas[i].instituicao_id == this.dados.instituicao_id) {
            for(let j in this.vagas[i].turnos) {
                if(j == this.dados.turno){
                    this.modalidades = this.vagas[i].turnos[j];
                }
            }
        }
      }
      this.step++;
    },
    selecionaModalidade(){

        this.step = 4;

        for(let i in this.vagas) {
          if(this.vagas[i].instituicao_id == this.dados.instituicao_id) {
              for(let j in this.vagas[i].turnos) {
                  if(j == this.dados.turno){
                    for(let w in this.vagas[i].turnos[j]) {
                      if(w == this.dados.modalidade){
                        this.dados.tipo_ensino = this.vagas[i].turnos[j][w].tipo_ensino;
                      }
                    }                      
                  }
              }
          }
        }
        this.step++;
    },
    onsubmit() {

      this.loadingForm = true;

      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/salvarPrematricula`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

        if(typeof response.data.erro !== 'undefined'){

          this.erro = response.data.erro;
          this.loadingForm = false;
        
        }else{
          
          if(response.data.status == true){
            this.$router.push(`/inscricao/status/${this.dados.codigo}`);  
          }

        }

      }).catch((error) => { this.$store.commit('throwException', error); this.loadingForm = false; });

    },   
    goBack(){
      this.step--;
    },
    onSubmitBuscaMatricula() {  

      this.loadingInst = true;

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getDadosByCodTransferencia/${this.dados.codigo}`, this.$store.getters.getHeaderAuth).then(response => {
        
        if(typeof response.data.erro !== 'undefined'){

          this.erro = response.data.erro;
        
        }else{

          this.dados.matricula_id = response.data.matricula.id;

          this.dados.codigo = response.data.matricula.cod_transferencia;
          this.matricula = response.data.matricula;
          this.vagas = response.data.vagas;
          this.step++;
        }

        this.loadingInst = false;

      }).catch((error) => { this.$store.commit('throwException', error); });   
    },
  },
  components: {

  },
};
</script>
